import { render, staticRenderFns } from "./TBPerPage.vue?vue&type=template&id=f48b1530&scoped=true"
import script from "./TBPerPage.vue?vue&type=script&lang=js"
export * from "./TBPerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b1530",
  null
  
)

export default component.exports